<script lang="ts">
	import { useSidebar } from '$lib/components/ui/sidebar/context.svelte.js';
	import PanelLeftIcon from '@lucide/svelte/icons/panel-left';

	// Open WebUI's sidebar toggles: the header "Close Sidebar" button (a
	// 30px rounded-lg ghost with the sidebar glyph) and the collapsed rail's
	// logo button, whose logo swaps to the same glyph on hover. Lives in its own
	// component because useSidebar() needs the Provider context.
	let { variant = 'header' }: { variant?: 'header' | 'rail' } = $props();

	const sidebar = useSidebar();
</script>

{#if variant === 'rail'}
	<!-- Named group (`group/rail`): the shadcn sidebar root is itself `.group`,
	     so a bare group-hover would swap the logo whenever the rail is hovered. -->
	<button
		type="button"
		class="group/rail flex size-8.5 cursor-[e-resize] items-center justify-center transition"
		aria-label="Open sidebar"
		title="Open sidebar"
		onclick={() => sidebar.toggle()}
	>
		<span
			class="flex size-[30px] items-center justify-center self-center rounded-lg transition group-hover/rail:bg-gray-100 dark:group-hover/rail:bg-gray-900"
		>
			<span
				class="flex size-5 items-center justify-center rounded-full bg-black text-white group-hover/rail:hidden dark:bg-white dark:text-black"
				aria-hidden="true"
			>
				<span class="block size-1.5 rounded-full bg-current"></span>
			</span>
			<PanelLeftIcon class="hidden size-4 group-hover/rail:flex" aria-hidden="true" />
		</span>
	</button>
{:else}
	<button
		type="button"
		class="flex size-[1.875rem] cursor-[w-resize] items-center justify-center rounded-lg transition hover:bg-gray-100 dark:hover:bg-gray-900"
		aria-label="Close sidebar"
		title="Close sidebar"
		onclick={() => sidebar.toggle()}
	>
		<PanelLeftIcon class="size-4" aria-hidden="true" />
	</button>
{/if}
